import { FormInformation } from "@/modules/GeneralRules/models/FormInformationMapped.model";
import { FORM_MESSAGES } from "@/shared/constants/FormConstants";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import Vuetify from "vuetify";
import {
  DATA_TYPES,
  FORM_ACTION_CONSTANTS,
  CALC_OPERATORS,
  CALC_ALLOWED_KEYS
} from "../../constants/FormActionModal.constants";
import { SPECIAL_CHARS_REGEX } from "@/shared/constants/GeneralConstants";

Vue.use(Vuetify);
@Component({ name: "CalculatorComponent" })
export default class CalculatorComponent extends Vue {
  @Prop({ default: "" }) operation!: string;
  @Prop({ default: () => [] }) formInformationArray!: FormInformation[];
  @Prop({ default: () => [] }) arrayTypeFormula?:
    | [{ title: string; name: string; key: string }]
    | undefined;
  @Prop({ default: true }) inputEdited?: boolean;

  calculatorBtnClass = STYLE_CLASSES.CALCULATOR_BTN;
  textFieldClass = STYLE_CLASSES.TEXT_FIELD;
  primaryIconClass = STYLE_CLASSES.PRIMARY_ICON;

  CALCULATOR_LABEL = FORM_ACTION_CONSTANTS.LABELS.CALCULATOR;
  CALCULATOR_HINT = FORM_ACTION_CONSTANTS.HINT.CALCULATOR;
  CALCULATOR_HELP = FORM_ACTION_CONSTANTS.LABELS.CALCULATOR_HELP;
  CLEAR = FORM_ACTION_CONSTANTS.TOOLTIP.CLEAR;
  DELETE = FORM_ACTION_CONSTANTS.TOOLTIP.DELETE;
  ADITION = FORM_ACTION_CONSTANTS.TOOLTIP.ADITION;
  SUBSTRACTION = FORM_ACTION_CONSTANTS.TOOLTIP.SUBSTRACTION;
  MULTIPLICATION = FORM_ACTION_CONSTANTS.TOOLTIP.MULTIPLICATION;
  DIVISION = FORM_ACTION_CONSTANTS.TOOLTIP.DIVISION;
  allowedKeys = CALC_ALLOWED_KEYS;

  requiredFieldTxt = [
    (value: any) => !!value || FORM_MESSAGES.REQUIRED_FIELD,
    (value: any) => {
      const tokens = this.tokenize(value);
      return (
        (tokens && tokens.length
          ? this.validateTokens(tokens) && this.isParenthesesBalanced()
          : true) || FORM_MESSAGES.INVALID_FORMAT
      );
    }
  ];
  operators = [
    CALC_OPERATORS.ADDITION,
    CALC_OPERATORS.SUBSTRACTION,
    CALC_OPERATORS.MULTIPLICATION,
    CALC_OPERATORS.DIVISION
  ];
  localOperation = "";
  visualOperation = "";
  cursorPositionGet = 0;
  actualInputGet = {} as HTMLInputElement;
  localInformationArray: FormInformation[] = [];

  mounted() {
    this.mapOperation(this.operation);
  }

  @Watch("operation", { deep: true })
  mapOperation(value: string) {
    this.localOperation = value;
    this.visualOperation = value;
    this.mapVisualizationOperation(value);
    this.formInformationGet();
  }

  handleKeyPress(event: KeyboardEvent) {
    const pressedKey = event.key;

    if (this.allowedKeys.includes(pressedKey)) {
      switch (pressedKey) {
        case CALC_OPERATORS.BACKSPACE:
          this.deleteEnclosedVariable();
          break;
        default:
          this.calculatorOnClick(pressedKey);
      }
    } else {
      event.preventDefault();
    }
  }

  mapVisualizationOperation(value: string) {
    for (const info of this.formInformationArray) {
      value = value.replaceAll(`{{${info.key}}}`, `{{${info.name}}}`);
    }
    if (this.arrayTypeFormula != undefined) {
      for (const info of this.arrayTypeFormula) {
        value = value.replaceAll(`{{${info.key}}}`, `{{${info.name}}}`);
      }
    }
    this.visualOperation = value;
  }

  @Watch("visualOperation", { deep: true })
  localOperationWatcher() {
    this.$emit(
      FORM_ACTION_CONSTANTS.EVENTS.OPERATIONS.CALCULATOR_UPDATE,
      this.visualOperation
    );
  }

  @Watch("formInformationArray", { deep: true })
  formInformationGet() {
    if (this.formInformationArray.length > 0) {
      this.localInformationArray = this.formInformationArray.filter(
        formInformation =>
          formInformation.dataType === DATA_TYPES.NUMBER ||
          formInformation.dataType === DATA_TYPES.FORMULA
      );
    }
  }

  calculatorOnClick(value: string) {
    this.visualOperation = [
      this.visualOperation.slice(0, this.cursorPositionGet),
      value,
      this.visualOperation.slice(this.cursorPositionGet)
    ].join("");

    this.localOperation = [
      this.localOperation.slice(0, this.cursorPositionGet),
      value,
      this.localOperation.slice(this.cursorPositionGet)
    ].join("");

    this.$nextTick(() => {
      const newPosition = this.cursorPositionGet + value.length;

      this.actualInputGet.selectionStart = newPosition;
      this.actualInputGet.selectionEnd = newPosition;
      this.captureCursorPosition();
    });
  }

  formInformationOnClick(item: FormInformation) {
    const valueVisualOperation = `{{${item.name}}}`;
    const valueLocalOperation = `{{${item.key}}}`;

    this.visualOperation = [
      this.visualOperation.slice(0, this.cursorPositionGet),
      valueVisualOperation,
      this.visualOperation.slice(this.cursorPositionGet)
    ].join("");

    this.localOperation = [
      this.localOperation.slice(0, this.cursorPositionGet),
      valueLocalOperation,
      this.localOperation.slice(this.cursorPositionGet)
    ].join("");

    this.$nextTick(() => {
      const newPosition = this.cursorPositionGet + valueVisualOperation.length;

      this.actualInputGet.selectionStart = newPosition;
      this.actualInputGet.selectionEnd = newPosition;
      this.captureCursorPosition();
    });
  }

  deleteOnClick() {
    if (this.localOperation) {
      this.localOperation = this.localOperation.slice(0, -1);
      this.visualOperation = this.visualOperation.slice(0, -1);
    }
  }
  deleteEnclosedVariable() {
    this.captureCursorPosition();

    if (
      this.visualOperation.substring(
        this.cursorPositionGet - 2,
        this.cursorPositionGet
      ) === CALC_OPERATORS.BRACKET_CLOSE
    ) {
      let start = this.cursorPositionGet - 2;
      while (
        start > 0 &&
        this.visualOperation.substring(start - 2, start) !==
          CALC_OPERATORS.BRACKET_OPEN
      ) {
        start--;
      }
      this.visualOperation =
        this.visualOperation.substring(0, start - 2) +
        this.visualOperation.substring(this.cursorPositionGet);
      this.cursorPositionGet = start - 2;
      this.captureCursorPosition();

      return;
    }

    const isOpeningAroundCursor =
      this.visualOperation.substring(
        this.cursorPositionGet - 1,
        this.cursorPositionGet + 1
      ) === CALC_OPERATORS.BRACKET_OPEN;
    const isClosingAroundCursor =
      this.visualOperation.substring(
        this.cursorPositionGet - 1,
        this.cursorPositionGet + 1
      ) === CALC_OPERATORS.BRACKET_CLOSE;

    if (isOpeningAroundCursor || isClosingAroundCursor) {
      let start = this.cursorPositionGet - 1;
      let end = this.cursorPositionGet + 1;

      if (isOpeningAroundCursor) {
        while (
          end < this.visualOperation.length &&
          this.visualOperation.substring(end, end + 2) !==
            CALC_OPERATORS.BRACKET_CLOSE
        ) {
          end++;
        }
        end += 2;
      } else {
        while (
          start > 0 &&
          this.visualOperation.substring(start - 2, start) !==
            CALC_OPERATORS.BRACKET_OPEN
        ) {
          start--;
        }
        start -= 2;
      }

      this.visualOperation =
        this.visualOperation.substring(0, start) +
        this.visualOperation.substring(end);
      this.cursorPositionGet = start;
      this.captureCursorPosition();
      return;
    }

    if (
      this.visualOperation.substring(
        this.cursorPositionGet - 1,
        this.cursorPositionGet
      ) === CALC_OPERATORS.BRACKET_SIMPLE_OPEN &&
      this.visualOperation.substring(
        this.cursorPositionGet - 1,
        this.cursorPositionGet
      ) === CALC_OPERATORS.BRACKET_SIMPLE_CLOSE &&
      this.visualOperation.substring(
        this.cursorPositionGet,
        this.cursorPositionGet + 1
      ) === CALC_OPERATORS.BRACKET_SIMPLE_OPEN &&
      this.visualOperation.substring(
        this.cursorPositionGet,
        this.cursorPositionGet + 1
      ) === CALC_OPERATORS.BRACKET_SIMPLE_CLOSE
    ) {
      const start = this.cursorPositionGet;
      const end = this.cursorPositionGet;

      this.visualOperation =
        this.visualOperation.substring(0, start) +
        this.visualOperation.substring(end);
      this.captureCursorPosition();
      return;
    }
    const leftCloseBracePos = this.visualOperation.lastIndexOf(
      CALC_OPERATORS.BRACKET_CLOSE,
      this.cursorPositionGet
    );
    const rightOpenBracePos = this.visualOperation.indexOf(
      CALC_OPERATORS.BRACKET_OPEN,
      this.cursorPositionGet
    );

    if (leftCloseBracePos !== -1 && rightOpenBracePos !== -1) {
      this.visualOperation =
        this.visualOperation.substring(0, this.cursorPositionGet - 1) +
        this.visualOperation.substring(this.cursorPositionGet);
      this.cursorPositionGet = this.cursorPositionGet - 1;
      this.captureCursorPosition();
      return;
    }

    const leftOpenBracePos = this.visualOperation.lastIndexOf(
      CALC_OPERATORS.BRACKET_OPEN,
      this.cursorPositionGet
    );
    const rightCloseBracePos = this.visualOperation.indexOf(
      CALC_OPERATORS.BRACKET_CLOSE,
      this.cursorPositionGet
    );

    if (leftOpenBracePos !== -1 && rightCloseBracePos !== -1) {
      this.visualOperation =
        this.visualOperation.substring(0, leftOpenBracePos) +
        this.visualOperation.substring(rightCloseBracePos + 2);
      this.cursorPositionGet = leftOpenBracePos;
      this.captureCursorPosition();
      return;
    }

    if (this.cursorPositionGet > 0) {
      this.visualOperation =
        this.visualOperation.substring(0, this.cursorPositionGet - 1) +
        this.visualOperation.substring(this.cursorPositionGet);
      this.cursorPositionGet = this.cursorPositionGet - 1;
      this.captureCursorPosition();
    }
  }

  tokenize(expr: string) {
    if (this.arrayTypeFormula != undefined) {
      const variables = [
        ...this.arrayTypeFormula.map(f => f.title),
        ...this.localInformationArray.map(l => l.name)
      ];
      if (variables.length == 0) {
        return [];
      }
      const regexEspecialChars = new RegExp(
        `[${SPECIAL_CHARS_REGEX.map(char => `\\${char}`).join("")}]`,
        "g"
      );
      const varsPattern = variables
        .map(v => v.replace(regexEspecialChars, char => `\\${char}`))
        .map(v => `{{${v}}}`)
        .join("|");
      const regex = new RegExp(`(${varsPattern}|\\d+|[+\\-*/])`, "g");
      return expr.match(regex) || [];
    }
  }
  validateTokens(tokens: any) {
    let expectOperand = true;
    let parenCount = 0;

    for (let i = 0; i < tokens.length; i++) {
      const token = tokens[i];

      if (expectOperand) {
        if (token === CALC_OPERATORS.PARENTHESES_OPEN) {
          parenCount++;
          continue;
        }

        if (!this.isVariableOrNumber(token)) return false;
        expectOperand = false;
      } else {
        if (token === CALC_OPERATORS.PARENTHESES_CLOSE) {
          parenCount--;
          if (parenCount < 0) return false;
          expectOperand = false;
          continue;
        }

        if (!this.operators.includes(token)) return false;
        expectOperand = true;
      }
    }

    return parenCount === 0 && !expectOperand;
  }

  isParenthesesBalanced() {
    const stack: any = [];
    let char = "";
    for (char of this.visualOperation) {
      if (char === CALC_OPERATORS.PARENTHESES_OPEN) {
        stack.push(char);
      } else if (char === CALC_OPERATORS.PARENTHESES_CLOSE) {
        if (
          stack.length === 0 ||
          stack.pop() !== CALC_OPERATORS.PARENTHESES_OPEN
        )
          return false;
      }
    }
    return stack.length === 0;
  }

  isVariableOrNumber(token: any) {
    if (this.arrayTypeFormula != undefined) {
      const variables = [
        ...this.arrayTypeFormula.map(f => f.title),
        ...this.localInformationArray.map(l => l.name)
      ];
      return variables.includes(token.replace(/{{|}}/g, "")) || !isNaN(token);
    }
  }

  captureCursorPosition() {
    this.$nextTick(() => {
      const inputComponent = this.$refs.myInput as Vue & {
        $el: HTMLElement;
      };
      const actualInput = inputComponent.$el.querySelector(
        "textarea"
      ) as HTMLTextAreaElement;

      if (!actualInput) return;

      this.cursorPositionGet = actualInput.selectionStart;

      this.$nextTick(() => {
        actualInput.selectionStart = this.cursorPositionGet;
        actualInput.selectionEnd = this.cursorPositionGet;
        actualInput.focus();
      });
    });
  }

  clearOnClick() {
    this.localOperation = "";
    this.visualOperation = "";
  }
}
